<template>
    <div class="flex flex-col w-full">
        <Menu as="div" class="relative flex-shrink-0 flex border-b border-gray-200 dark:border-gray-700">
            <Float placement="top-start" strategy="absolute" :offset="{mainAxis: 100, crossAxis: 16}">
                <MenuButton class="w-full p-4 text-white">
                    Currently on {{ defaultServiceCenter }}
                </MenuButton>

                <transition enter-active-class="transition ease-out duration-100"
                            enter-from-class="transform opacity-0 scale-95"
                            enter-to-class="transform opacity-100 scale-100"
                            leave-active-class="transition ease-in duration-75"
                            leave-from-class="transform opacity-100 scale-100"
                            leave-to-class="transform opacity-0 scale-95">
                    <MenuItems class="origin-top-center absolute w-64 mt-2 rounded-md shadow-2xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div class="py-1">
                            <MenuItem
                                v-for="serviceCenter in auth.user.service_centers" :key="serviceCenter.name" v-slot="{ active }">
                                <a @click="switchServiceCenter(serviceCenter)"
                                    :class="[serviceCenter.active ? 'font-medium text-gray-900' : 'text-gray-500', active ? 'bg-gray-100' : '', 'cursor-pointer block px-4 py-2 text-sm']">
                                    Switch to {{ serviceCenter.name }}
                                </a>
                            </MenuItem>
                        </div>
                    </MenuItems>
                </transition>
            </Float>
        </Menu>
        <div class="flex flex-row p-4">
            <Link
                as="a"
                method="get"
                :href="$route('profile')"
                class="flex-grow group block">
                <div class="flex items-center">
                    <div>
                        <img class="inline-block h-10 w-10 rounded-full" src="https://images.unsplash.com/photo-1517365830460-955ce3ccd263?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80" alt="" />
                    </div>
                    <div class="ml-3">
                        <p class="text-sm font-medium text-gray-700 dark:text-gray-200 group-hover:text-gray-900 dark:group-hover:text-gray-400">{{ userFullName }}</p>
                        <p class="text-xs text-gray-700 dark:text-gray-200 group-hover:text-gray-900 dark:group-hover:text-gray-400">{{ userEmailAddress }}</p>
                        <p class="text-sm font-light text-gray-400 dark:text-gray-300">{{ userRoles }}</p>
                    </div>
                </div>
            </Link>
            <Link as="button" type="button" method="delete" :href="$route('logout')"
                  class="group block px-1 border border-gray-300 text-sm font-thin rounded-md text-white bg-orange-500 hover:bg-reethi-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500">
                <LogoutIcon class="ml-1 mr-1 h-4 w-4" aria-hidden="true" />
            </Link>
        </div>
    </div>
</template>

<script>
import {
    LogoutIcon,
    ChevronDownIcon
} from '@heroicons/vue/solid'
import { Link } from '@inertiajs/inertia-vue3'
import { Float, FloatArrow } from '@headlessui-float/vue'
import { Menu, MenuItem, MenuItems, MenuButton } from '@headlessui/vue'
import axios from "axios";

export default {
    components: {
        Link,
        LogoutIcon,
        ChevronDownIcon,

        Menu,
        Float,
        MenuItem,
        MenuItems,
        MenuButton,
        FloatArrow,
    },
    props: {
        auth: Object,
    },
    computed: {
        defaultServiceCenter() {
            return this.auth.user.selected_service_center?.name;
        },
        userFullName() {
            return this.auth.user.name
        },
        userEmailAddress() {
            return this.auth.user.email
        },
        userRoles() {
            return this.auth.user.roles.map(role => role.name).join(", ")
        }
    },
    methods: {
        async switchServiceCenter(serviceCenter) {
            try {
                await axios.post(this.$route('users.switch.center', {code: serviceCenter.code}))
                this.$inertia.reload()
            } catch (e) {
                if (e.response) {
                    this.$page.props.flash = {
                        error: e.response.data.message
                    }
                } else {
                    console.error(e)
                }
            }
        }
    }
}
</script>
